import styled from 'styled-components';

interface Props {
  isEdition: undefined | boolean;
}

export const HTMLContainer = styled.div<Props>`
  position: absolute;
  top: 5vh;
  bottom: 5vh;
  right: 5vw;
  left: 5vw;
  display: flex;
  align-content: center;
  justify-content: center;
  font-size: 2vw;
  ${(props): string => {
    if (props.isEdition === true) {
      return `
        &:hover {
          -webkit-box-shadow: inset 0 0 2px 0 black;
          box-shadow: inset 0 0 2px 0 black;
        }
      `;
    }
    return '';
  }}
`;
HTMLContainer.displayName = 'HTMLContainer';
